/** True if the string contains Hebrew letters (Unicode Hebrew block). */
export function containsHebrewScript(text: string): boolean {
  return /[\u0590-\u05FF]/.test(text);
}

/**
 * Paragraph direction for chat composers and bubbles.
 * Content wins once there is strong script; empty fields follow the UI language
 * so placeholders and the first keystrokes match user expectation.
 */
export function resolveChatTextDir(
  text: string,
  uiLanguage: string,
): 'rtl' | 'ltr' {
  const trimmed = text.trim();
  if (!trimmed) {
    return uiLanguage === 'he' ? 'rtl' : 'ltr';
  }
  return containsHebrewScript(trimmed) ? 'rtl' : 'ltr';
}
